import React from "react"

const BackArrow = (props) => {
  return (
    <button className="clock-in-panel__right-arrow" onClick={props.onClickBack} title="Back">
      <img src="/images/clock-in/right.png"/>
    </button>
  )
}

export default BackArrow
